import { FormLayout, Stack } from '@customerio/pluma-components/react';
import {
  BucketNameAndPathFields,
  bucketPreviewPath,
  ConfigTextField,
  CredentialsHelp,
  RegionSelect,
  TooltipLink,
  UploadPathPreview,
} from './fields';
import { AWS_REGION_OPTIONS } from './regions';
import type { ProviderFormProps } from './types';

const AWS_CREDENTIALS_DOCS_URL = 'https://docs.aws.amazon.com/general/latest/gr/aws-sec-cred-types.html';

function consoleUrl(path: string): string {
  return `https://s3.console.aws.amazon.com/s3/buckets/${path}`;
}

/** Bucket, credentials and region for an Amazon S3 sync. */
export function S3Form(props: ProviderFormProps) {
  const path = bucketPreviewPath(props.config);

  return (
    <FormLayout>
      <BucketNameAndPathFields form={props} />

      <UploadPathPreview
        scheme="s3"
        path={path}
        tooltip={
          <>
            View files in your Amazon S3 console: <TooltipLink href={consoleUrl(path)}>{consoleUrl(path)}</TooltipLink>
          </>
        }
      />

      <Stack>
        <CredentialsHelp>
          <>
            Your keys can be found in the My Security Credentials section of your AWS Management Console. Learn more
            about <TooltipLink href={AWS_CREDENTIALS_DOCS_URL}>AWS credentials</TooltipLink>.
          </>
        </CredentialsHelp>

        <ConfigTextField form={props} field="access_key" label="Access key" isSecret autofocus={false} />
      </Stack>

      <ConfigTextField form={props} field="secret_key" label="Secret key" isSecret autofocus={false} />

      <RegionSelect form={props} label="AWS region" options={AWS_REGION_OPTIONS} />
    </FormLayout>
  );
}
